import React from "react";
import { Footer } from "v2/components/footer";
import { Header } from "v2/components/hearder";
import { makeStyles } from "@material-ui/core";
import image from "v2/components/images/1.png";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  item: {
    background: "rgba(196, 196, 196, 0.14)",
    padding: 20,
    margin: 20,
    width: "100%",
    borderRadius: 15,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
    },
  },
  imageContent: {
    margin: 20,
    width: "100%",
    borderRadius: 15,
    display: "flex",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
    },
  },
  title: {
    fontWeight: 600,
    paddingLeft: 18,
    color: "#3c4858",
    marginTop:'auto',
  },
  img: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
  text: {
    textAlign: "center",
    marginBottom: "auto",
  },
  element: {
    margin: 20,
    display: "flex",
    flexDirection: "column",
  },
}));
export function About() {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.center}>
        <div className={styles.imageContent}>
          <img src={image} className={styles.img} />
        </div>
        <div className={styles.item}>
          <div className={styles.element}>
            <div className={styles.title}>Offre de service</div>
            <div className={styles.text}>
              Nous offrons un service de transport de qualité respectant les
              normes sécuritaires. Nous mettons en relation instantanée des
              clients avec des chauffeurs particuliers.
            </div>
          </div>
          <div className={styles.element}>
            <div className={styles.title}>Activité</div>
            <div className={styles.text}>
              <div>Transfert et Navette Aéroport</div>
              <div>Taxi et VTC dans Dakar/Thies/Mbour</div>
              <div>Déménagement et Transport de marchandises</div>
            </div>
          </div>
          <div className={styles.element}>
            <div className={styles.title}>Fonctionnement</div>
            <div className={styles.text}>
              Une fois le trajet validé avec le prix, notre système informatique
              vous transmettra un code de réservation. Ce code de réservation
              vous permettra de payer la course avec Orange Money, SendWave.
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
